import { IDataRow, IODataResult } from "Entities";
import { CommandService } from "Service";
import { Configuration } from "Configuration";
import { BaseService } from "./BaseService";
import { CommandResult, DataRequestOption, DropDownRequestParameter, MultipleControlRequestParameter, PeoplePickerClient } from "./Client";

export class PeoplePickerService extends BaseService {
    /**
     * Get data for all comboboxes in an EditContext.
     * @param gridId Id of the grid.
     * @param options List of request options.
     * @param dataRow Current datarow in grid / form.
     */
    public getAll(gridId: number, options: DataRequestOption[], dataRow: IDataRow): Promise<{ [controlID: number]: IODataResult }> {
        let client = new PeoplePickerClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        let param = <MultipleControlRequestParameter>(
            $.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOptions: options })
        );

        return this.handleResult(
            new Promise<{ [controlID: number]: IODataResult }>((resolve, reject) => {
                /*let xhr = */ client.get(
                    gridId,
                    param,
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // token.onCancelled(reason => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }

    /**
     * Get data for a single combobox.
     * @param gridId Id of the grid.
     * @param controlId Id of the combobox control.
     * @param option Request option.
     * @param dataRow Current datarow in grid / form.
     */
    public get(gridId: number, controlId: number, option: DataRequestOption, dataRow: IDataRow): Promise<IODataResult> {
        let client = new PeoplePickerClient(Configuration.baseUrl);
        let params = <DropDownRequestParameter>(
            $.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOption: option })
        );
        client.beforeSend = this.getBeforeSend();

        return new Promise<CommandResult>((resolve, reject) => {
            client.getControl(
                gridId,
                controlId,
                params,
                (res) => resolve(res),
                (exc, res) => reject(exc)
            );
        });
    }
}
